import React from 'react';
import {
  ApolloProvider,
  ApolloClient,
  NormalizedCacheObject,
} from '@apollo/client';

interface Props {
  client?: ApolloClient<NormalizedCacheObject>;
  children: JSX.Element;
}

export function ApolloProviderWrapper({
  client,
  children,
}: Props): JSX.Element {
  if (!client) return children;

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
